import {
  CashIcon,
  FolderIcon,
  MegaphoneIcon,
  PhotoClickIcon,
  UserCheckIcon,
} from "@pharmupp/p3-front-commons"
import { GridContainer } from "../commons"
import { ExternalLinkCard } from "./ExternalLinkCard"

export const OpeazOperationsSummary = () => (
  <GridContainer>
    <ExternalLinkCard
      title="Opérations"
      Icon={MegaphoneIcon}
      type="ALL"
      variant="neutral"
    />
    <ExternalLinkCard
      title="Inscriptions"
      Icon={UserCheckIcon}
      type="PARTICIPATING"
      variant="info"
    />
    <ExternalLinkCard
      title="À justifier"
      Icon={PhotoClickIcon}
      type="PENDING_PROOF"
      variant="warning"
    />
    <ExternalLinkCard
      title="Compensations à demander"
      Icon={CashIcon}
      type="UNREQUESTED_COMPENSATIONS"
      variant="warning"
    />
    <ExternalLinkCard
      title="Demandes transmises"
      Icon={FolderIcon}
      type="COMPENSATED"
      variant="success"
      divider={false}
    />
  </GridContainer>
)
